// components/CameraGridSection.js
import React, { useState } from "react";

const CameraGridSection = ({
  images = [],
  onSelectionChange,
  gridDisplaySize,
}) => {
  //console.log("images", images);
  const [selectedImages, setSelectedImages] = useState([]);

  const toggleImage = (img) => {
    const updatedSelection = selectedImages.includes(img)
      ? selectedImages.filter((i) => i !== img)
      : [...selectedImages, img];

    setSelectedImages(updatedSelection);
    if (onSelectionChange) {
      onSelectionChange(updatedSelection);
    }
  };

  return (
    <div className={`cameraGrid ${gridDisplaySize}`}>
      {images &&
        images?.data?.map((img, idx) => (
          <div
            key={idx}
            className={`image-box ${
              selectedImages.includes(img) ? "selected" : ""
            }`}
            onClick={() => toggleImage(img)}
          >
            <img
              src={`https://visionemptrack.greymatterz.com/stream2/stream2/${img._id}`}
              alt={`Camera ${idx}`}
            />
            <span className="toggle-icon">
              {selectedImages.includes(img) ? "−" : "+"}
            </span>
          </div>
        ))}
    </div>
  );
};

export default CameraGridSection;
